<app-heading [title]="projectsTypeTitle | sentenceCase" [button]="clientMode() ? null : headingButton" [showToggle]="false"></app-heading>
<div class="projects-data">
    <div class="grid grid-nogutter">
        <div class="col-12 p-0">
            <div class="grid grid-nogutter">
                <div class="col-12 md:col-6 xl:col-4 lg:col-6 sm:col-12 p-0">
                    <div class="wrap-left">
                       <div class="grid grid-nogutter">
                            @if(!clientMode()){
                            <div class="md:pr-1 sm:pr-0 col-12 md:col-6 sm:col-12 ">
                                <p-iconField iconPosition="right">
                                    <p-inputIcon styleClass="pi pi-search" />
                                    <input [(ngModel)]="searchText" (keydown)="onEnter($event)" type="text" pInputText [placeholder]="'Search Projects' | sentenceCase" />
                                </p-iconField>
                            </div>
                            }
                            <div class="p-0 col-12 md:col-12 sm:col-12">
                                <ul class="chips">
                                    @for (searchLabel of searchedItems; track searchedItems;) {
                                        <li><p-chip label="{{searchLabel}}" [removable]="true" (onRemove)="clearProjectSearch()" /></li>
                                     }
                                </ul>
                            </div>
                       </div>
                    </div>
                </div>
                <div class="col-12 md:col-6 xl:col-8 lg:col-6 sm:col-12 p-0 flex md:justify-content-end justify-content-center my-2 md:my-0">
                    <div class="wrap-right">
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0">
            <div class="p-datatable-striped">
                <p-table 
                #dt
                [value]="projects"
                styleClass="p-datatable-sm p-datatable-sm--normal"
                [tableStyle]="{ 'min-width': '50rem' }"
                [rows]="10"
                [paginator]="true"
                [totalRecords]="projectsCount"
                [lazy]="true"
                (onLazyLoad)="getProjects($event)"
                [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
                autoLayout="true"
                [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width:23%">
                                Name
                            </th>
                            @if(clientMode() || (projectType != 'ARCHIVED' && projectType!= 'UNPUBLISHED')){
                                <th style="width:22%">
                                    Published date
                                </th>
                                <th style="width:22%">
                                    Filled positions
                                </th>
                            }
                            @if(!clientMode() && projectType === 'UNPUBLISHED'){
                                <th style="width:22%">
                                    Step
                                </th>
                            }
                            @if(!clientMode() && projectType === 'ARCHIVED'){
                                <th style="width:22%">
                                    Ended date
                                </th>
                            }
                            @if (clientMode()) {
                                <!-- MP-5752: no row actions in client mode -->
                              } @else if (helperService.checkResponsive()) {
                                <th alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                              } @else {
                                <th>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                              }
                              <ng-template #frozenHeader>
                                Actions
                              </ng-template>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-project>
                        <tr class="table-data" (click)="goToProjectDetails(project)" style="cursor:pointer;">
                            <td>{{ project.codeName }}</td>
                            @if(clientMode() || (projectType !== 'ARCHIVED' && projectType !== 'UNPUBLISHED')){
                            <td>{{ project.publishedAt | date: 'MM/dd/YYYY'}}</td>
                            <td>{{ project.positionsFilled }}/{{ project.positionsListed}}</td>
                            }
                            @if(!clientMode() && projectType === 'UNPUBLISHED'){
                                <td>{{ project.step}}/5</td>
                          
                            }
                            @if(!clientMode() && projectType === 'ARCHIVED'){
                                <td>{{ project.archivedAt | date: 'MM/dd/YYYY'}}</td>
                            
                            }
                            @if (clientMode()) {
                              } @else if (helperService.checkResponsive()) {
                                <td alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="content"></ng-container>
                                </td>
                              } @else {
                                <td>
                                  <ng-container *ngTemplateOutlet="content"></ng-container>
                                </td>
                              }
                              <ng-template #content>
                                <div class="wrap-actions flex align-items-center gap-2">

                                    @if(projectType !== 'ARCHIVED'){
                                    <p-button pTooltip="Edit" 
                                    tooltipPosition="top"  [rounded]="true" [text]="true" icon="true" (click)="onEdit($event,project)">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                                    </p-button>
                                   
                                    <p-button pTooltip="Archive" 
                                    tooltipPosition="top"  (click)="showArchiveConfirmation($event,project)" [rounded]="true" [text]="true" icon="true">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-archive-outlined red"></span>
                                    </p-button>
                                    }
                                    @if(projectType === 'ARCHIVED' && !project.isDeleted){
                                        <p-button pTooltip="Restore project" 
                                        tooltipPosition="top" (click)="projectRestore($event,project)" [rounded]="true" [text]="true" icon="true">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-sync-outlined"></span>
                                        </p-button>
                                    }
                                    @if(projectType === 'ARCHIVED'){
                                        <p-button pTooltip="Remove project"
                                        tooltipPosition="top" (click)="showRemoveConfirmation($event,project)" [rounded]="true" [text]="true" icon="true">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                                        </p-button>
                                    }
                                </div>
                            </ng-template>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
<!-- <app-rate-freelancers/> -->


